import {
  useCompanyReadDataContext,
  usePersonReadDataContext,
} from '@aibees/elephant/context';
import { useBrowseUpdatedCompanies } from '@aibees/elephant/feature/search-table-company/hooks/use-browse-updated-companies';
import { useBrowseUpdatedPeople } from '@aibees/elephant/feature/search-table-people/hooks/use-browse-updated-people';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { useReadPersonChanges } from '@aibees/elephant/hooks/people/use-read-person-changes';
import { ROUTES } from '@aibees/elephant/router';
import { SearchType } from '@aibees/elephant/types';
import { useMatchRoute } from '@aibees/shared/hooks';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useReadCompanyChanges } from './company/use-read-company-changes';
import { useBrowseSearchIds } from './use-browse-search-ids';

export function useInvalidateCompanyAndPeopleQueries(
  searchTypeOverrride?: SearchType,
  invalidateSearchIds?: boolean
) {
  const routeType = useSearchTypeFromRoute();
  const isCompanyPage = useMatchRoute(ROUTES.company);
  const isPeoplePage = useMatchRoute(ROUTES.people);
  const type = searchTypeOverrride ?? routeType;

  const browseUpdatedCompaniesMutation = useBrowseUpdatedCompanies();
  const browseUpdatedPeopleMutation = useBrowseUpdatedPeople();
  const { api: personReadApi } = usePersonReadDataContext();
  const { debouncedRefetch: personReadDebouncedRefetch } = useReadPersonChanges(
    personReadApi?.data?.id
  );

  const { api: companyReadApi } = useCompanyReadDataContext();
  const { debouncedRefetch: comapnyReadDebouncedRefetch } =
    useReadCompanyChanges(companyReadApi?.data?.id);

  return () => {
    if (type === SearchType.People) {
      if (!isPeoplePage) browseUpdatedPeopleMutation.mutate();
      personReadDebouncedRefetch();
    } else {
      if (!isCompanyPage) browseUpdatedCompaniesMutation.mutate();
      comapnyReadDebouncedRefetch();
    }
    if (invalidateSearchIds) {
      baseQueryClient.invalidateQueries([useBrowseSearchIds.name]);
    }
  };
}
